<template>
    <div>
        <div id="contain-all" v-show="showHTML">
            <h3 id="chamada" v-html="chamada"></h3>

            <div id="img1-container" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_1.code + '_face.png'">
            </div>
            <p id="titulo-1" v-html="product_1.name"></p>
            <p id="carac-1" v-html="product_1.feature"></p>
            <div id="container-price-1" v-show="this.theme === 'vqt'">
                <p id="values-1">
                    à vista: {{ product_1.sight_price }}
                </p>
                <div style="width: 100%; height: 110px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-1">{{ product_1.payment_x }}x</p>
                        <p id="prefix-1">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-1">
                            {{ product_1.payment_price }},<small>{{ product_1.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-1">
                    Total a prazo {{ product_1.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-1" v-show="this.theme != 'vqt'">
                <div style="width: 20%; float: left; line-height: 0;">
                    <p style="font-size: 32px">{{ product_1.payment_x }}x</p>
                    <p style="font-size: 52px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 124px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_1.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_1.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 22px; float: left; width: 100%" v-html="product_1.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 38px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_1.sight_price }}</p>
                <p class="reset" style="font-size: 22px; float: left; width: 100%">Total a prazo {{ product_1.forward_price }}</p>
            </div>
            


            <div id="img2-container" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_2.code + '_face.png'">
            </div>
            <p id="titulo-2" v-html="product_2.name"></p>
            <p id="carac-2" v-html="product_2.feature"></p>
            <div id="container-price-2" v-show="this.theme === 'vqt'">
                <p id="values-2">
                    à vista: {{ product_2.sight_price }}
                </p>
                <div style="width: 100%; height: 110px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-2">{{ product_2.payment_x }}x</p>
                        <p id="prefix-2">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-2">
                            {{ product_2.payment_price }},<small>{{ product_2.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-2">
                    Total a prazo {{ product_2.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-2" v-show="this.theme != 'vqt'">
                <div style="width: 20%; float: left; line-height: 0;">
                    <p style="font-size: 32px">{{ product_2.payment_x }}x</p>
                    <p style="font-size: 52px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 124px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_2.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_2.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 22px; float: left; width: 100%" v-html="product_2.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 38px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_2.sight_price }}</p>
                <p class="reset" style="font-size: 22px; float: left; width: 100%">Total a prazo {{ product_2.forward_price }}</p>
            </div>

            <div id="img3-container" v-resize-image>
                <img @load="incrementLoad" :src="'https://circular.rxy.com.br/api/public/imgs/' + product_3.code + '_face.png'">
            </div>
            <p id="titulo-3" v-html="product_3.name"></p>
            <p id="carac-3" v-html="product_3.feature"></p>
            <div id="container-price-3" v-show="this.theme === 'vqt'">
                <p id="values-3">
                    à vista: {{ product_3.sight_price }}
                </p>
                <div style="width: 100%; height: 110px">
                    <div style="width: 25%; float: left;">
                        <p id="parcelas-3">{{ product_3.payment_x }}x</p>
                        <p id="prefix-3">R$</p>	
                    </div>
                    <div style="width: 75%; float: left;">
                        <p id="price-parcela-3">
                            {{ product_3.payment_price }},<small>{{ product_3.payment_price_cents }}</small>
                        </p>
                    </div>
                </div>
                <p id="preco-prazo-3">
                    Total a prazo {{ product_3.forward_price }}
                </p>
            </div>

            <div id="container-price-theme-23-3" v-show="this.theme != 'vqt'">
                <div style="width: 20%; float: left; line-height: 0;">
                    <p style="font-size: 32px">{{ product_3.payment_x }}x</p>
                    <p style="font-size: 52px; color: #2c46f6; font-family: Segoe UI Bold;">R$</p>
                </div>
                <div style="width: 70%; float: left; padding-top: 5px">
                    <p class="reset" style="font-family: Segoe UI Bold; font-size: 124px; font-weight: bold; color: #2c46f6; line-height: 0.6">{{ product_3.payment_price }}<span style="font-family: Segoe UI Bold;font-size: 38px; font-weight: bold; position: absolute; top: 0; transform: translateY(50%)">,{{ product_3.payment_price_cents }}</span></p>
                </div>
                <p class="reset" style="font-size: 22px; float: left; width: 100%" v-html="product_3.options_buy"></p>
                <p class="reset" style="font-family: Segoe UI Bold; font-size: 38px; font-wight: bold; color: #2c46f6; float: left; width: 100%">À VISTA {{ product_3.sight_price }}</p>
                <p class="reset" style="font-size: 22px; float: left; width: 100%">Total a prazo {{ product_3.forward_price }}</p>
            </div>

            <!-- old -->

            <img @load="incrementLoad" :src="require('../../assets/banners/' + this.banner + '.png')" id="banner" alt="">

            <div id="juridico">
                <p>{{ juridico }}</p>
            </div>
        </div>
        <!-- <img :src="output" v-show="output != null" id="download" crossorigin="anonymous"> -->
        <p v-show="showHTML === false && url === null">Imagem sendo gerada, aguarde...</p>
        <img v-show="url !== null" :src="url" alt="Imagem para Download" height="700px" class="responsive-img">
        <a :href="url" target="_blank" v-show="url !== null" download style="background: #039be5;color: #fff;padding: 10px 10px;border-radius: 5px;">Baixar imagem</a>
        <a href="/" v-show="url !== null" style="background: #EE0000;color: #fff;padding: 10px 10px;border-radius: 5px;">Voltar para tela inicial</a>
    </div>
</template>

<script>
function fold(input, lineSize, lineArray) {
    lineArray = lineArray || [];
    if (input.length <= lineSize) {
        lineArray.push(input);
        return lineArray;
    }
    lineArray.push(input.substring(0, lineSize));
    var tail = input.substring(lineSize);
    return fold(tail, lineSize, lineArray);
}

function sliceWords(str, size) {
	var trimmedString = str.substr(0, size);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))

    return trimmedString;
}

import { BASE_URL_API, SYSTEM_ENV } from "../../config.js";

export default {
    name: "generate2x",
    data() {
        return {
            items: [],
            abrangencia: null,
            chamada: null,
            dtinicio: null,
            dtfim: null,
            juridico: null,
            theme: this.theme,
            banner: null,
            background_color: null,
            url: null,
            showHTML: true,
            allLoaded: 0,
            product_1: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null
            },
            product_2: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
            product_3: {
                name: "",
                id: null,
                price: null,
                sight_price: 0,
                forward_price: 0,
                payment_x: 0,
                payment_price: 0,
                payment_price_cents: 0,
                code: null,
                feature: null
            },
        }
    },
    created() {
        var body = document.body;
        var className = "body";
        if (body.classList)
            body.classList.add(className);
        else
            body.className += ' ' + className;

        var html = document.querySelector("html");
        var className = "html";
        if (html.classList)
            html.classList.add(className);
        else
            html.className += ' ' + className;

        this.items = this.$route.params.items;
        this.abrangencia = this.$route.params.abrangencia;
        let linha1 = sliceWords(this.$route.params.chamada + " ", 25);
        let chamada_total = this.$route.params.chamada;
        let linha2 = sliceWords(this.$route.params.chamada.replace(linha1, "") + " ", 25);
        this.chamada = linha1 + "<br />" + linha2;
        this.dtinicio = this.$route.params.dtinicio;
        this.dtfim = this.$route.params.dtfim;

        this.theme = this.$route.params.theme;
        this.banner = this.$route.params.banner;
        this.background_color = this.$route.params.background_color;

        document.body.style.backgroundColor = this.background_color;

        var classNameBody = '';
        var classNameChamada = '';
        switch (this.theme) {
            case 'dga':
                classNameBody = 'tema-2';
                classNameChamada = 'chamada-tema-2';
                break;
            case 'ang':
                classNameBody = 'tema-3';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'oug':
                classNameBody = 'tema-4';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'dma':
                classNameBody = 'tema-5';
                classNameChamada = 'chamada-tema-3';
                break;
            case 'mgf':
                classNameBody = 'tema-6';
                classNameChamada = 'chamada-tema-3';
                break;
        }

        if (classNameBody != '') {
            var body = document.body;
            if (body.classList)
                body.classList.add(classNameBody);
            else
                body.className += ' ' + classNameBody;
        }

        if (classNameChamada != '') {
            setTimeout(function() {
                var chamada = document.querySelector("#chamada");
                if (chamada.classList)
                    chamada.classList.add(classNameChamada);
                else
                    chamada.className += ' ' + classNameChamada;
            }, 1000);
        }

        this.juridico = this.mounta_juridico();

        // Produto 1

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto1 = sliceWords(this.items[0].name + " ", 30);
        
        var firstLine1 = sliceWords(txtCompleto1, 18);
        txtCompleto1 = txtCompleto1.replace(firstLine1 + " ", "");
        var secondLine1 = sliceWords(txtCompleto1 + " ", 18);

        var lines1 = [firstLine1, secondLine1];

        this.product_1.name = lines1.join("<br />");
        this.product_1.sight_price = Number(this.items[0].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_1.forward_price = Number(this.items[0].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price1 = String(this.items[0].payment_price).split(".");
        this.product_1.payment_price = Number(payment_price1[0]);
        this.product_1.payment_price_cents = Number(payment_price1[1]);
        if (String(this.product_1.payment_price_cents).length < 2) {
            this.product_1.payment_price_cents = this.pad_with_zeroes(this.product_1.payment_price_cents, 2);
        }
        if (isNaN(this.product_1.payment_price_cents)) {
            this.product_1.payment_price_cents = '00';
        }
        this.product_1.payment_x = this.items[0].payment_x;
        this.product_1.code = this.items[0].code;
        this.product_1.feature = this.items[0].features;

        this.product_1.without_entrance = this.items[0].without_entrance;
        this.product_1.without_interest = this.items[0].without_interest;
        this.product_1.in_carne = this.items[0].in_carne;
        this.product_1.in_card = this.items[0].in_card;

        this.product_1.options_buy = '';

        if (this.product_1.without_entrance && this.product_1.without_interest) {
            this.product_1.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_1.without_entrance)
                this.product_1.options_buy = "Sem Entrada";
            else if (this.product_1.without_interest)
                this.product_1.options_buy = "Sem Juros";
        }

        if (this.product_1.without_entrance || this.product_1.without_interest) {
            if (this.product_1.in_carne || this.product_1.in_card)
                this.product_1.options_buy += " | ";
        }

        if (this.product_1.in_carne && this.product_1.in_card) {
            this.product_1.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_1.in_carne)
                this.product_1.options_buy += "Carnê";
            else if (this.product_1.in_card)
                this.product_1.options_buy += "Cartão";
        }

        this.product_1.options_buy = this.product_1.options_buy.split("|");
        if (this.product_1.options_buy.length > 1) {
            this.product_1.options_buy = this.product_1.options_buy.join("<br>");
        } else {
            this.product_1.options_buy = this.product_1.options_buy[0];
        }

        // Produto 2

        // let name2 = fold(this.items[1].name.slice(0, 30), 18).join('<br/>');

        var txtCompleto2 = sliceWords(this.items[1].name + " ", 30);
        // console.log('txt', txtCompleto2);
        var firstLine2 = sliceWords(txtCompleto2, 18);
        // console.log('txt', firstLine2);
        txtCompleto2 = txtCompleto2.replace(firstLine2 + " ", "");
        // console.log('txt', txtCompleto2);
        var secondLine2 = sliceWords(txtCompleto2 + " ", 18);

        var lines2 = [firstLine2, secondLine2];

        this.product_2.name = lines2.join("<br />");
        this.product_2.sight_price = Number(this.items[1].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_2.forward_price = Number(this.items[1].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price2 = String(this.items[1].payment_price).split(".");
        this.product_2.payment_price = Number(payment_price2[0]);
        this.product_2.payment_price_cents = Number(payment_price2[1]);
        if (String(this.product_2.payment_price_cents).length < 2) {
            this.product_2.payment_price_cents = this.pad_with_zeroes(this.product_2.payment_price_cents, 2);
        }
        if (isNaN(this.product_2.payment_price_cents)) {
            this.product_2.payment_price_cents = '00';
        }
        this.product_2.payment_x = this.items[1].payment_x;
        this.product_2.code = this.items[1].code;
        this.product_2.feature = this.items[1].features;

        this.product_2.without_entrance = this.items[1].without_entrance;
        this.product_2.without_interest = this.items[1].without_interest;
        this.product_2.in_carne = this.items[1].in_carne;
        this.product_2.in_card = this.items[1].in_card;

        this.product_2.options_buy = '';

        if (this.product_2.without_entrance && this.product_2.without_interest) {
            this.product_2.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_2.without_entrance)
                this.product_2.options_buy = "Sem Entrada";
            else if (this.product_2.without_interest)
                this.product_2.options_buy = "Sem Juros";
        }

        if (this.product_2.without_entrance || this.product_2.without_interest) {
            if (this.product_2.in_carne || this.product_2.in_card)
                this.product_2.options_buy += " | ";
        }

        if (this.product_2.in_carne && this.product_2.in_card) {
            this.product_2.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_2.in_carne)
                this.product_2.options_buy += "Carnê";
            else if (this.product_2.in_card)
                this.product_2.options_buy += "Cartão";
        }

        this.product_2.options_buy = this.product_2.options_buy.split("|");
        if (this.product_2.options_buy.length > 1) {
            this.product_2.options_buy = this.product_2.options_buy.join("<br>");
        } else {
            this.product_2.options_buy = this.product_2.options_buy[0];
        }

        // Produto 3

        // let name1 = fold(this.items[0].name.slice(0, 30), 18).join('<br/>');
        var txtCompleto3 = sliceWords(this.items[2].name + " ", 30);
        
        var firstLine3 = sliceWords(txtCompleto3, 18);
        txtCompleto3 = txtCompleto3.replace(firstLine3 + " ", "");
        var secondLine3 = sliceWords(txtCompleto3 + " ", 18);

        var lines3 = [firstLine3, secondLine3];

        this.product_3.name = lines3.join("<br />");
        this.product_3.sight_price = Number(this.items[2].sight_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        this.product_3.forward_price = Number(this.items[2].forward_price).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
        let payment_price3 = String(this.items[2].payment_price).split(".");
        this.product_3.payment_price = Number(payment_price3[0]);
        this.product_3.payment_price_cents = Number(payment_price3[1]);
        if (String(this.product_3.payment_price_cents).length < 2) {
            this.product_3.payment_price_cents = this.pad_with_zeroes(this.product_3.payment_price_cents, 2);
        }
        if (isNaN(this.product_3.payment_price_cents)) {
            this.product_3.payment_price_cents = '00';
        }
        this.product_3.payment_x = this.items[2].payment_x;
        this.product_3.code = this.items[2].code;
        this.product_3.feature = this.items[2].features;

        this.product_3.without_entrance = this.items[2].without_entrance;
        this.product_3.without_interest = this.items[2].without_interest;
        this.product_3.in_carne = this.items[2].in_carne;
        this.product_3.in_card = this.items[2].in_card;

        this.product_3.options_buy = '';

        if (this.product_3.without_entrance && this.product_3.without_interest) {
            this.product_3.options_buy = "Sem Entrada / Sem Juros";
        } else {
            if (this.product_3.without_entrance)
                this.product_3.options_buy = "Sem Entrada";
            else if (this.product_3.without_interest)
                this.product_3.options_buy = "Sem Juros";
        }

        if (this.product_3.without_entrance || this.product_3.without_interest) {
            if (this.product_3.in_carne || this.product_3.in_card)
                this.product_3.options_buy += " | ";
        }

        if (this.product_3.in_carne && this.product_3.in_card) {
            this.product_3.options_buy += "Carnê / Cartão";
        } else {
            if (this.product_3.in_carne)
                this.product_3.options_buy += "Carnê";
            else if (this.product_3.in_card)
                this.product_3.options_buy += "Cartão";
        }

        this.product_3.options_buy = this.product_3.options_buy.split("|");
        if (this.product_3.options_buy.length > 1) {
            this.product_3.options_buy = this.product_3.options_buy.join("<br>");
        } else {
            this.product_3.options_buy = this.product_3.options_buy[0];
        }
    },
    mounted() {
        if (SYSTEM_ENV === 1) {
            let interval = setInterval(() => {
                if (this.allLoaded === 4) {
                    clearInterval(interval);

                    window.scrollTo(0,0);

                    let self = this;

                    html2canvas(document.body, {
                        width: 1758,
                        allowTaint: true,
                        taintTest: false,
                    }).then(canvas => {
                        self.showHTML = false;

                        this.removeClass(document.body, "body");
                        this.removeClass(document.body, "tema-2");
                        this.removeClass(document.body, "tema-3");
                        this.removeClass(document.body, "tema-4");
                        this.removeClass(document.body, "tema-5");
                        this.removeClass(document.querySelector("html"), "html");

                        var img = canvas.toDataURL();

                        const token = localStorage.getItem("user-token");
                        this.$http.post(BASE_URL_API + '/save-image', { token, image: img }).then(response => {
                            response.json().then(json => {
                                // window.open(json.url);
                                this.url = json.url;
                            });
                        }, response => {
                            // error callback
                            alert('Ocorreu ao tentar salvar a imagem. Entre em contato com o suporte.')
                        });
                        // console.log(img);
                        // var download = document.querySelector("#download");
                        // download.src = img;
                        // download.style.display = "block";

                        // document.querySelector("#contain-all").style.display = "none";
                        this.removeClass(document.body, "body");
                        this.removeClass(document.querySelector("html"), "html");

                        // self.output = img;
                        self.$forceUpdate();
                    });
                }
            }, 1000);
        }
    },
    destroyed() {
        this.removeClass(document.body, "body");
        this.removeClass(document.querySelector("html"), "html");
    },
    methods: {
        removeClass(el, className) {
            if (el.classList)
            el.classList.remove(className);
            else
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        incrementLoad() {
            this.allLoaded++;
        },
        pad_with_zeroes(number, length) {
            var my_string = '' + number;
            while (my_string.length < length) {
                my_string = my_string + '0';
            }

            return my_string;
        },
        mounta_juridico() {
            let valid = `Oferta válida de ${this.formatDate(this.dtinicio)} até ${this.formatDate(this.dtfim)} ou enquanto durar o estoque.`
            let to = "Para";
            let c = 0;
            this.abrangencia.forEach((el, ind) => {
                to += ((c === 0) ? " " : ", ") + el.nome;
                c++;
            });
            to += ".";
            let complement = "Crédito sujeito a aprovação.";
            return valid + " " + to + " " + complement;
        },
        formatDate(dt){
            var _str = dt;
            var _new = _str.split('-').reverse().join('/');
            return _new;
        }
    }
}
</script>

<style lang="scss">
    * {
        -webkit-print-color-adjust: exact !important;   /* Chrome, Safari */
        color-adjust: exact !important;                 /*Firefox*/
    }

    @font-face {
        font-family: 'Segoe UI';
        font-style: normal;
        font-weight: normal;
        src: local('Segoe UI'), url('../../assets/segoeui.woff') format('woff');
    }

    @font-face {
        font-family: 'Segoe UI Bold';
        font-style: normal;
        font-weight: bold;
        src: url('../../assets/Segoe UI Bold.woff') format('woff');
    }


    * {
        font-family: Segoe UI;
    }

    #juridico {
        position: absolute;
        top: 2508px;
        width: 1663px;
        left: 55px;
    }

    #juridico p {
        margin: 0;
        width: 100%;
    }

    #download {
        height: 100vh;
        width: auto;
    }

    .html2canvas-container { width: 3000px !important; height: 3000px !important; }

    @font-face {
        font-family: 'Helvetica Neue LT';
        font-weight: 500;
        src: url('../../assets/HelveticaNeueLTStd-BlkCnO.otf') format('opentype');
    }

    h3#chamada {
        text-align: left;
        position: absolute;
        top: 200px;
        left: 60px;
        font-size: 62px;
        font-family: 'Helvetica Neue LT';
        font-weight: 500;
        color: #EE0000;
    }

    .html {
        width: 1770px;
        height: 2560px;
        padding: 0;
        margin: 0;
    }

    .body {
        background-image: url('../../assets/base_circular_vqt.png');
        background-size: cover;
        background-repeat: no-repeat;
        width: 1758px;
        height: 2560px;
        /*border: 1px solid red;*/
        padding: 0;
        margin: 0;
    }

    #banner {
        width: 1770px;
        position: absolute;
        top: 2344px;
    }

    .tema-2 {
        background-image: url('../../assets/base_circular_dia.png') !important;
    }

    .tema-3 {
        background-image: url('../../assets/base_circular_niver.png') !important;
    }

    .tema-4 {
        background-image: url('../../assets/base_outlet.png') !important;
    }

    .tema-5 {
        background-image: url('../../assets/base_circular_maes.png') !important;
    }

    .tema-6 {
        background-image: url('../../assets/base_feirao.png') !important;
    }

    .chamada-tema-2 {
        top: 280px !important;
        left: 90px !important;
    }

    .chamada-tema-3 {
        top: 330px !important;
        left: 60px !important;
    }

    .tema-2 div[id^="container-price-"] p[id^="price-parcela-"] {
        color: #2c46f6 !important;
    }

    .tema-2 div[id^="container-price-"] p[id^="price-parcela-"] small {
        color: #2c46f6 !important;
    }

    .tema-2 div[id^="container-price-"] p[id^="prefix-"] {
        color: #2c46f6 !important;
    }

    .tema-3 div[id^="container-price-"] p[id^="price-parcela-"] {
        color: #2c46f6 !important;
    }

    .tema-3 div[id^="container-price-"] p[id^="price-parcela-"] small {
        color: #2c46f6 !important;
    }

    .tema-3 div[id^="container-price-"] p[id^="prefix-"] {
        color: #2c46f6 !important;
    }

    p#options-buy-1 {
        position: absolute;
        top: 885px;
        left: 1120px;
        text-align: left;
    }
    p#options-buy-2 {
        position: absolute;
        top: 1785px;
        left: 265px;
        text-align: left;
    }

    p.reset {
        margin: 0;
        padding: 0;
    }
    #container-price-theme-23-1 {
        width: 480px;
        height: 300px;
        position: absolute;
        top: 885px;
        left: 1150px;
    }

    #container-price-theme-23-2 {
        width: 480px;
        height: 300px;
        position: absolute;
        top: 1795px;
        left: 485px;
    }

    #container-price-theme-23-3 {
        width: 480px;
        height: 300px;
        position: absolute;
        top: 1795px;
        left: 1325px;
    }

    img {
        // width: auto;
        // height: auto;
        /*position: relative;
        left: 50%;
        transform: translateX(-50%);*/
    }

    #img1-container {
        width: 1000px;
        position: absolute;
        top: 490px;
        height: 800px;
        overflow: hidden;
        left: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    #titulo-1 {
        color: #151515;
        position: absolute;
        top: 546px;
        left: 1120px;
        font-size: 44px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: right;
        width: 400px;
        height: 130px;
        overflow: hidden;
    }

    #carac-1 {
        color: #151515;
        position: absolute;
        top: 705px;
        left: 1115px;
        font-size: 28px;
        text-align: right;
        width: 412px;
        height: 150px;
        overflow: hidden;
    }

    #container-price-1 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 450px;
        position: absolute;
        top: 925px;
        left: 1070px;
        padding: 10px 0px;
    }

    #container-price-1 #values-1 {
        color: #151515;
        font-size: 42px;
        margin: 0;
        margin-left: 50px;
    }

    #container-price-1 #preco-prazo-1 {
        font-size: 28px;
        margin: 0;
        margin-left: 70px;
    }

    #container-price-1 #price-parcela-1 {
        font-size: 100px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 40px;
        font-weight: 900;
    }

    #container-price-1 #price-parcela-1 small {
        font-size: 36px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 70px;
        font-weight: 900;
    }

    #container-price-1 #parcelas-1 {
        padding: 0;
        margin: 0;
        font-size: 32px;
        line-height: 1;
        margin-left: 58px;
        margin-top: 10px;
    }

    #container-price-1 #prefix-1 {
        padding: 0;
        margin: 0;
        font-size: 32px;
        line-height: 1;
        margin-left: 58px;
        margin-top: 10px;
        color: #fa7b19;
    }

    /* img 2 */

    #img2-container {
        position: absolute;
        top: 1320px;
        left: 50px;
        width: 400px;
        height: 1000px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    // #img2-container img {
    //     width: 100% !important;
    //     height: auto;
    // }

    #titulo-2 {
        color: #151515;
        position: absolute;
        top: 1515px;
        left: 410px;
        font-size: 34px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: right;
        width: 430px;
        height: 130px;
        overflow: hidden;
    }

    #carac-2 {
        color: #151515;
        position: absolute;
        top: 1625px;
        left: 430px;
        font-size: 24px;
        text-align: right;
        width: 412px;
        height: 150px;
        overflow: hidden;
    }

    #container-price-2 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 370px;
        position: absolute;
        top: 1805px;
        left: 475px;
        padding: 10px 0px;
    }

    #container-price-2 #values-2 {
        color: #151515;
        font-size: 32px;
        margin: 0;
        margin-left: 50px;
    }

    #container-price-2 #preco-prazo-2 {
        font-size: 24px;
        margin: 0;
        margin-left: 50px;
    }

    #container-price-2 #price-parcela-2 {
        font-size: 76px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 90px;
        font-weight: 900;
    }

    #container-price-2 #price-parcela-2 small {
        font-size: 36px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 60px;
        font-weight: 900;
    }

    #container-price-2 #parcelas-2 {
        padding: 0;
        margin: 0;
        font-size: 28px;
        line-height: 1;
        margin-left: 58px;
        margin-top: 10px;
    }

    #container-price-2 #prefix-2 {
        padding: 0;
        margin: 0;
        font-size: 28px;
        line-height: 1;
        margin-left: 58px;
        margin-top: 10px;
        color: #fa7b19;
    }


    /* img 3 */

    #img3-container {
        position: absolute;
        top: 1320px;
        left: 900px;
        width: 400px;
        height: 1000px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    // #img3-container img {
    //     width: 100% !important;
    //     height: auto;
    // }

    #titulo-3 {
        color: #151515;
        position: absolute;
        top: 1515px;
        left: 1290px;
        font-size: 34px;
        text-transform: uppercase;
        font-weight: 900;
        text-align: right;
        width: 430px;
        height: 130px;
        overflow: hidden;
    }

    #carac-3 {
        color: #151515;
        position: absolute;
        top: 1625px;
        left: 1325px;
        font-size: 24px;
        text-align: right;
        width: 392px;
        height: 150px;
        overflow: hidden;
    }

    #container-price-3 {
        border: 4px solid #151515;
        border-radius: 55px;
        width: 370px;
        position: absolute;
        top: 1805px;
        left: 1345px;
        padding: 10px 0px;
    }

    #container-price-3 #values-3 {
        color: #151515;
        font-size: 32px;
        margin: 0;
        margin-left: 50px;
    }

    #container-price-3 #preco-prazo-3 {
        font-size: 24px;
        margin: 0;
        margin-left: 50px;
    }

    #container-price-3 #price-parcela-3 {
        font-size: 76px;
        margin: 0;
        color: #fa7b19;
        line-height: 1;
        margin-left: 90px;
        font-weight: 900;
    }

    #container-price-3 #price-parcela-3 small {
        font-size: 36px;
        margin: 0;
        color: #fa7b19;
        position: absolute;
        top: 60px;
        font-weight: 900;
    }

    #container-price-3 #parcelas-3 {
        padding: 0;
        margin: 0;
        font-size: 28px;
        line-height: 1;
        margin-left: 58px;
        margin-top: 10px;
    }

    #container-price-3 #prefix-3 {
        padding: 0;
        margin: 0;
        font-size: 28px;
        line-height: 1;
        margin-left: 58px;
        margin-top: 10px;
        color: #fa7b19;
    }
</style>





// WEBPACK FOOTER //
// src/components/generate3x/Generate3x.vue